"use client";

import styles from "./Checkbox.module.scss";
import classNames from "classnames";
import * as CheckboxBase from "@radix-ui/react-checkbox";
import { CheckIcon } from "@vetty/icons";
import { ReactNode } from "react";

const CheckboxLabel = ({ children }: { children: ReactNode | string }) => {
  return <div className={styles["comp__label"]}>{children}</div>;
};

const CheckboxCaption = ({ children }: { children: ReactNode | string }) => {
  return <div className={styles["comp__caption"]}>{children}</div>;
};

const Checkbox = ({
  defaultValue = false,
  checked = undefined,
  children,
  id,
  onChange = () => {},
  variant = "default",
  disabled = false,
}: {
  defaultValue?: boolean;
  checked?: boolean | undefined;
  children: ReactNode;
  id: string;
  onChange?: (value: boolean) => void;
  variant?: "default" | "lightAlert";
  disabled?: boolean;
}) => {
  return (
    <div className={styles["comp"]}>
      <CheckboxBase.Root
        disabled={disabled}
        defaultChecked={defaultValue}
        onCheckedChange={onChange}
        className={styles["comp__root"]}
        checked={checked}
        id={id}
      >
        <CheckboxBase.Indicator className={styles["comp__indicator"]}>
          <CheckIcon />
        </CheckboxBase.Indicator>
      </CheckboxBase.Root>

      <label
        className={classNames(
          styles["comp__label"],
          styles[`comp__label--${variant}`]
        )}
        htmlFor={id}
      >
        {children}
      </label>
    </div>
  );
};

Checkbox.Label = CheckboxLabel;
Checkbox.Caption = CheckboxCaption;
export { Checkbox, CheckboxLabel, CheckboxCaption };
